import isLpuPromotionsSectionVisible from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPromotions/functions/isLpuPromotionsSectionVisible'
import getSectionMenuPromotionsCount from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/SectionMenu/functions/getSectionMenuPromotionsCount'

/**
 * Видимость «Акции» в меню: список promotions или promotions_count (как в django TOC).
 */
export default function isSectionMenuPromotionsVisible({
  promotions,
  promotionsCount,
  isMobile,
  isStaff,
}: {
  promotions: unknown
  promotionsCount?: number
  isMobile: boolean
  isStaff: boolean
}): boolean {
  return isLpuPromotionsSectionVisible({
    promotionsLength: getSectionMenuPromotionsCount(promotions, promotionsCount) ?? 0,
    isMobile,
    isStaff,
  })
}
